import { render, staticRenderFns } from "./CoNote.vue?vue&type=template&id=76633ff6&scoped=true&"
import script from "./CoNote.vue?vue&type=script&lang=ts&"
export * from "./CoNote.vue?vue&type=script&lang=ts&"
import style0 from "./CoNote.vue?vue&type=style&index=0&id=76633ff6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76633ff6",
  null
  
)

export default component.exports